import { buildMarketplaceAuctionBrowseHref } from "./auctionBrowse";
import { buildMarketplaceInfraBrowseHref } from "./infrastructureLeasingBrowse";

export function formatMarketplaceTabCount(count) {
  const value = Number(count) || 0;
  return value > 0 ? ` (${value})` : "";
}

export function buildMarketplaceProductsHref({ categoryId, subCategoryId, subSubCategoryId } = {}) {
  const params = new URLSearchParams();
  if (categoryId) params.set("category", String(categoryId));
  if (subCategoryId) params.set("subCategory", String(subCategoryId));
  if (subSubCategoryId) params.set("subSubCategory", String(subSubCategoryId));
  const qs = params.toString();
  return qs ? `/marketplace/products?${qs}` : "/marketplace/products";
}

export function buildMarketplaceBuyerRequirementsHref({ categoryId, subCategoryId } = {}) {
  const params = new URLSearchParams();
  if (categoryId) params.set("category", String(categoryId));
  if (subCategoryId) params.set("subCategory", String(subCategoryId));
  const qs = params.toString();
  return qs ? `/seller-rfq-list?${qs}` : "/seller-rfq-list";
}

export function buildMarketplaceModuleTabs({
  activeKey,
  counts = {},
  categoryId,
  subCategoryId,
} = {}) {
  const {
    products = 0,
    buyerReqs = 0,
    auctions = 0,
    cm = 0,
  } = counts;

  const fmt = formatMarketplaceTabCount;

  return [
    {
      key: "products",
      label: `Products${fmt(products)}`,
      href: buildMarketplaceProductsHref({ categoryId, subCategoryId }),
      active: activeKey === "products",
    },
    {
      key: "buyer-reqs",
      label: `Buyer Requirements${fmt(buyerReqs)}`,
      href: buildMarketplaceBuyerRequirementsHref({ categoryId, subCategoryId }),
      active: activeKey === "buyer-reqs",
    },
    {
      key: "auctions",
      label: `Auctions${fmt(auctions)}`,
      href: buildMarketplaceAuctionBrowseHref(),
      active: activeKey === "auctions",
    },
    {
      key: "cm",
      label: `Contract Manufacturing${fmt(cm)}`,
      href: "/marketplace/products?module=cm",
      active: activeKey === "cm",
    },
    {
      key: "services",
      label: "Services",
      href: "/logistics-providers",
      active: activeKey === "services",
    },
    {
      key: "infra",
      label: "Infrastructure",
      href: buildMarketplaceInfraBrowseHref(),
      active: activeKey === "infra",
    },
  ];
}
